import React from 'react';

import { ItemBox, Link, SpanBold } from './ResourceItemCard.style';

export interface IResourceItemCard {
  label: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  href: string;
  isTargetBlank?: boolean;
  isLargeScreen?: boolean;
}

/**
 * Resource item card for the /help page
 *
 */
const ResourceItemCard: React.FC<IResourceItemCard> = ({
  label,
  Icon,
  href,
  isTargetBlank = false,
  isLargeScreen,
}) => {
  return (
    <Link href={href} target={isTargetBlank ? '_blank' : '_self'}>
      <ItemBox isLargeScreen={isLargeScreen}>
        <Icon />
        <SpanBold>{label}</SpanBold>
      </ItemBox>
    </Link>
  );
};

export default ResourceItemCard;
